// Static content for Ranchoddas Jivraj & Company

export const NAV_LINKS = [
  { label: "House", href: "#about" },
  { label: "Contact", href: "#inquire" },
  { label: "Sandalwood", href: "#sandalwood" },
  { label: "Saffron", href: "#saffron" },
  { label: "Heritage", href: "#heritage" },
  { label: "Ethos", href: "#ethos" },
];

export const ABOUT_PARAS = [
  "Ranchoddas Jivraj & Company is a heritage trading house founded in 1911, devoted to a single pursuit — sourcing the world's finest sandalwood and saffron and delivering them, unadulterated, to those who value the extraordinary.",
  "For over a century and across four generations, our name has been carried by merchants, perfumers, apothecaries and connoisseurs. We deal exclusively in aromatics of provenance: aged sandalwood heartwood and its logs, chips, steam-distilled oil and stone-milled powder — alongside the crimson threads of Kashmir and Iranian kesar.",
  "Ours is a house built on patience and trust. Every consignment is hand-graded, tested for purity and matched to the exact specification of the buyer — whether a single artisan or a wholesale export order. What we promise, we deliver.",
];

export const STATS = [
  { value: "1911", label: "The house established" },
  { value: "IV", label: "Generations of merchants" },
  { value: "06", label: "Signature aromatics" },
  { value: "100%", label: "Purity, guaranteed" },
];

export const OFFERINGS = [
  "Wholesale & bulk supply",
  "Bespoke grading to specification",
  "Steam distillation & curing",
  "Worldwide export & logistics",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Provenance Above All",
    body: "Every log, every thread is traced to its origin. We source only from groves and fields where time and terroir conspire to create the extraordinary.",
  },
  {
    no: "02",
    title: "The Patience of Age",
    body: "Sandalwood matures for decades before it yields its heartwood. We honour that patience — curing, grading and ageing with the discipline of four generations.",
  },
  {
    no: "03",
    title: "Purity, Unadulterated",
    body: "No fillers. No dyes. No shortcuts. Our saffron is hand-picked and our oils steam-distilled, delivered exactly as nature intended — nothing added, nothing taken.",
  },
  {
    no: "04",
    title: "A House of Trust",
    body: "Since 1911, our name has been our bond. Merchants, perfumers and connoisseurs return to us for one reason: what we promise, we deliver.",
  },
];

export const TIMELINE = [
  { year: "Origin", text: "A modest trading house is founded, dealing in aromatic woods and fine spices." },
  { year: "Growth", text: "The house expands into the saffron trade, building trusted sourcing relationships." },
  { year: "Craft", text: "A new generation formalises grading standards for sandalwood heartwood and oil." },
  { year: "Reach", text: "Distillation and curing are modernised; the name earns recognition among perfumers." },
  { year: "Today", text: "A century of trust upheld — supplying the finest sandalwood and kesar." },
];

export const SANDALWOOD = [
  {
    name: "Heartwood Logs",
    tag: "Santalum album",
    desc: "Aged, densely grained logs prized for carving and distillation — the purest expression of the tree.",
  },
  {
    name: "Sandalwood Chips",
    tag: "Graded & sorted",
    desc: "Hand-cut chips for incense and slow-burning ritual, releasing a warm, creamy sillage.",
  },
  {
    name: "Pure Sandalwood Oil",
    tag: "Steam distilled",
    desc: "High-santalol oil, distilled with patience — the coveted base of the world's great perfumes.",
  },
  {
    name: "Fine Sandalwood Powder",
    tag: "Stone milled",
    desc: "Silken powder for apothecary, skincare and devotional use, milled to a whisper-fine grain.",
  },
];

export const SAFFRON = [
  {
    name: "Kashmir Kesar",
    tag: "Mongra · Grade A+",
    desc: "Deep crimson threads from the fields of Pampore — intense colour, honeyed aroma, unmatched potency.",
  },
  {
    name: "Iranian Kesar",
    tag: "Sargol · Super Negin",
    desc: "All-red Persian stigmas, celebrated for their vivid dye and lingering, luxurious fragrance.",
  },
];

export const PRODUCT_OPTIONS = [
  "Sandalwood — Heartwood Logs",
  "Sandalwood — Chips",
  "Sandalwood — Oil",
  "Sandalwood — Powder",
  "Saffron — Kashmir Kesar",
  "Saffron — Iranian Kesar",
  "General / Bulk Enquiry",
];

export const IMAGES = {
  heroSandalwood:
    "https://images.unsplash.com/photo-1702001145743-094b0b7ead51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzYW5kYWx3b29kJTIwd29vZHxlbnwwfHx8fDE3ODQ5MDY5OTl8MA&ixlib=rb-4.1.0&q=85",
  sandalwoodIncense:
    "https://images.pexels.com/photos/15387681/pexels-photo-15387681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  saffronThreads:
    "/saffron-kashmir.webp",
  saffronMacro:
    "https://images.unsplash.com/photo-1560076124-fe336393ef76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzYWZmcm9uJTIwdGhyZWFkcyUyMG1hY3JvfGVufDB8fHx8MTc4NDkwNjk5OXww&ixlib=rb-4.1.0&q=85",
  heritageBrick:
    "https://images.pexels.com/photos/38290092/pexels-photo-38290092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heritageBuilding:
    "https://images.unsplash.com/photo-1617338727645-987dddeef332?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwaGVyaXRhZ2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg0OTA2OTk5fDA&ixlib=rb-4.1.0&q=85",
};
